import api from "./axios";

class ServiceTypeOfSchedule {
  async save(typeOfSchedule) {
    const { data } = await api.post("/typeOfSchedule", typeOfSchedule)
    return data.id;
  }

  async update(typeOfSchedule) {
    await api.put(`/typeOfSchedule/${typeOfSchedule.id}`, typeOfSchedule);
  }

  async delete(id) {
    await api.delete(`/typeOfSchedule/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/typeOfSchedule/${id}`);
    return data;
  }

  async fillComobobox() {
    const { data } = await api.get(`/typeOfSchedule/combobox`);
    return data;
  }
}

export default new ServiceTypeOfSchedule()